module.exports = __webpack_public_path__ + "img/discord-w.f64c829f.png";